export default "__VITE_ASSET__bvA7mujK__"